import { Canvas } from "@react-three/fiber";
import classes from "./Scene.module.css";

import { Stars } from "@react-three/drei";

import Earth from "../Earth/Earth";
import { Suspense } from "react";

const Scene = ({ onNoCatClick, onYesCatClick, hideYesCat, hideEarth }) => {
  return (
    <Canvas className={classes.canvas}>
      <Suspense fallback={null}>
        {!hideEarth && (
          <Earth
            onNoCatClick={onNoCatClick}
            onYesCatClick={onYesCatClick}
            hideYesCat={hideYesCat}
          />
        )}
      </Suspense>
      <Stars />
    </Canvas>
  );
};

export default Scene;
